import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

export function LoadingSpinner({ className, size = 'md', text }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-3',
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px]" role="status">
      <div
        className={cn(
          'animate-spin rounded-full border-border-c border-t-accent-c',
          sizeClasses[size],
          className
        )}
        aria-label={text || 'Loading'}
      />
      {text && <p className="mt-4 text-sm text-muted-foreground">{text}</p>}
      <span className="sr-only">{text || 'Loading...'}</span>
    </div>
  );
}
